<template>
  <section
    v-loading="loading"
    class="selected-test-preview"
    id="default-test-preview"
  >
    <el-tabs>
      <el-tab-pane
        v-for="(category, index) of getCaseCategoryData(test.case_type_code)"
        :key="index"
      >
        <template #label>
          <div class="custom-tabs-label">
            <span @click="showDefaultTests">
              {{ category.panel_title }}
            </span>
            <el-button
              class="custom-tab-close-btn"
              @click="removeCategory(category)"
              v-if="notCreateCase && isBillingUser && !isReleasePending"
              :disabled="hasCases"
            >
              <img
                src="@/assets/images/fax-tag-close.svg"
                alt="icon"
                width="30"
              />
            </el-button>
          </div>
        </template>
        <div class="default-modal">
          <div
            :class="
              this.caseType && this.caseType === 'RESPIRATORY_PATHOGEN_PANEL'
                ? 'respiratory-checkbox'
                : 'panel'
            "
            v-if="defaultTestsPopup"
          >
            <el-dialog v-model="defaultTestsPopup" class="w-60">
              <div class="dialog-header">
                <span class="header-part"> {{ category.panel_title }} </span>
                <el-button
                  size="medium"
                  class="el-white"
                  type="info"
                  plain
                  @click="defaultTestsPopup = false"
                >
                  <img
                    src="@/assets/images/icons/cases/close-btn.svg"
                    alt="icon"
                /></el-button>
              </div>
              <div
                class="popup-panels-blocks"
                :class="{ 'check-list-gt-women': isGTI_STI(category) }"
              >
                <ul class="check-list-check-list-default">
                  <li
                    v-for="(item, index) of getCategoryWiseTestsData(
                      category.case_type_code,
                      category.panel_code
                    )"
                    :key="index"
                  >
                    <el-checkbox-group
                      v-model="panelsTestsData.selectedTestIds"
                    >
                      <el-checkbox :label="item._id" :value="item" disabled>
                        {{ item.test_name }}
                      </el-checkbox>
                    </el-checkbox-group>
                  </li>
                </ul>
              </div>
            </el-dialog>
          </div>
        </div>       
      </el-tab-pane>
    </el-tabs>
  </section>
</template>

<script>
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import AppHelper from "@/mixins/AppHelper";
import { mapGetters } from "vuex";

export default {
  mixins: [UserPermissionsHelper, AppHelper],
  components: {},
  props: [
    "panelTestsData",
    "testType",
    "allSelectedTests",
    "caseType",
    "newCase",
  ],

  data() {
    return {
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup:[]
      },
      allTests: "",
      selectedTest: "",
      activeNameCollapse: "",
      BloodPanels: [],
      selectedBloodPanels: [],
      testsData: [],
      existed: [],
      loading: false,
      show: false,
      test: "",
      caseRouteNames: [
        "NewCase",
        "Case-Information-Update",
        "NewOrder",
        "Edit-Order-Info",
        "PendingCasesEdit",
        "Concurrent-Case-Information-Update",
      ],
      defaultTestsPopup: false,
    };
  },

  async mounted() {
    this.loading = true;
    this.test = this.testType;
    this.allTests = this.allSelectedTests;
    this.panelsTestsData = this.panelTestsData;

    this.testsData = JSON.parse(
      JSON.stringify(this.panelsTestsData.selectedTestIds)
    );
    this.selectedCoriellPanels = JSON.parse(
      JSON.stringify(this.panelsTestsData.selectedCoriellPanels)
    );
    this.loading = false;
  },
  computed: {
    ...mapGetters("auth", ["getAuthenticatedUser"]),
    ...mapGetters("labTests", [
      "getAllLabTests",
      "getNewLabGroupWiseTests",
      "getNewLabGroupPanelTests",
    ]),
    hasCases() {
      if (this.checkUser && !this.hasAllowedCaseType && !this.newCase) {
        return true;
      } else if (this.checkUser && this.hasAllowedCaseType && this.newCase) {
        return true;
      }
      return false;
    },
    checkUser() {
      if (
        this.getAuthenticatedUser &&
        this.getAuthenticatedUser.user_type == "LAB_TECHNOLOGIST"
      ) {
        return true;
      }
      return false;
    },
    hasAllowedCaseType() {
      if (
        this.getAuthenticatedUser.allowed_case_types &&
        this.getAuthenticatedUser.allowed_case_types.length
      ) {
        if (
          this.getCaseInformation &&
          this.getCaseInformation.case_types &&
          this.getCaseInformation.case_types.length
        ) {
          const cases = this.getCaseInformation.case_types;
          const casetypes = this.getAuthenticatedUser.allowed_case_types;

          if (cases.every((item) => casetypes.includes(item))) {
            return true;
          } else {
            return false;
          }
        }
      }
      return false;
    },
    ...mapGetters("cases", ["getCaseInformation", "getCorriellTestPanels"]),
    notCreateCase() {
      if (this.caseRouteNames.indexOf(this.$route.name) != -1) {
        return true;
      }
      return false;
    }
  },
  methods: {
    isGTI_STI(test) {
      if (test && test.case_type_code && test.case_type_code === "GTI_STI") {
        return true;
      }
      return false;
    },
    showDefaultTests() {
      this.defaultTestsPopup = true;
    },
    removeCategory(category) {
      let testName = category.panel_title;
      this.$confirm(
        `Are you sure want to remove this
        <br/>
        <b style="color:#0A5DA6">"${testName}"</b> test type ?`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).then(() => {
        let index = this.panelsTestsData.selectedCategories.findIndex(
          (e) => e.panel_id == category.panel_id
        );
        if (index > -1) {
          this.panelsTestsData.selectedCategories.splice(index, 1);
        }
        // Emit event to parent to refresh test tube information
        this.$emit('refresh-test-tubes');
      });
    },
    getCategoryWiseTestsData(caseType, category) {
      const data = this.getNewLabGroupPanelTests.filter(
        (el) => el.case_type_code === caseType && el.panel_code === category
      );
      return data;
    },
    getCaseCategoryData(caseType) {
      if (
        !this.panelsTestsData ||
        !Array.isArray(this.panelsTestsData.selectedCategories)
      ) {
        return [];
      }


      let selectedTestPanelIds = this.panelsTestsData.selectedCategories.filter(e => e.case_type_code === caseType).map(
        (e) => e.panel_id
      );

      let data = this.getNewLabGroupPanelTests.filter((e) =>
        selectedTestPanelIds.includes(e.panel_id)
      );

      return data.reduce((acc, current) => {
        const x = acc.find((item) => item.panel_id == current.panel_id);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
    }
  },
};
</script>
<style lang="scss">
#default-test-preview {
  .el-dialog {
    width: 60% !important;
    margin-top: 7vh;
  }
}
.default-modal {
  .respiratory-checkbox {
    .popup-panels-blocks {
      .check-list-check-list-default {
        grid-template-columns: repeat(2, 1fr);
      }
      .el-checkbox__label {
        color: #34495e;
        white-space: pre-wrap;
      }
    }
  }
}
</style>
